import { ColumnProps } from "antd/lib/table";
import { INTEGRATION_EAP_CONFIGURATION_ROUTE } from "config/route-consts";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  LayoutCell,
  LayoutHeader,
  OneLineText,
  StandardTable,
  //StatusLine,
} from "react3l-ui-library";
import InputSearch from "react3l-ui-library/build/components/Input/InputSearch";
// import { filterService } from "services/page-services/filter-service";
// import { listService } from "services/page-services/list-service";
// import { masterService } from "services/page-services/master-service";
// import { queryStringService } from "services/page-services/query-string-service";
// import {
//   getAntOrderType,
//   tableService,
// } from "services/page-services/table-service";
import nameof from "ts-nameof.macro";
//import { Edit24 } from "@carbon/icons-react";
import { authorizationService } from "services/common-services/authorization-service";
import { API_INTEGRATION_EAP_CONFIGURATION_PREFIX } from "config/api-consts";

import { menuRepository } from "repositories/menu-repository";
import { Menu, MenuFilter } from "models/Menu";
import { Spin, Switch } from "antd";
import { Close16, Send16 } from "@carbon/icons-react";
import { cloneDeep } from "lodash";
import appMessageService from "services/common-services/app-message-service";
import { queryStringService } from "services/page-services/query-string-service";
import {
  FilterActionEnum,
  filterService,
} from "services/page-services/filter-service";
/* end individual import */

function IntegrationEapConfigurationMaster() {
  const [translate] = useTranslation();

  const { validAction } = authorizationService.useAuthorizedAction(
    INTEGRATION_EAP_CONFIGURATION_ROUTE.split("/")[
      INTEGRATION_EAP_CONFIGURATION_ROUTE.split("/").length - 1
    ],
    API_INTEGRATION_EAP_CONFIGURATION_PREFIX
  );

  const [menuList, setMenuList] = useState<Menu[]>([]);
  const [menuListDefault, setMenuListDefault] = useState<Menu[]>([]);
  const [modelFilter, dispatch] = queryStringService.useQueryString(
    MenuFilter,
    { skip: 0, take: 10 }
  );
  const [isData, setIsData] = useState<boolean>(false);
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const { value: filter, handleChangeInputSearch } = filterService.useFilter(
    modelFilter,
    dispatch
  );

  useEffect(() => {
    if (!isData) {
      menuRepository
        .listEnableIntegrationEap({ ...filter })
        .subscribe((mapping: Menu[]) => {
          setIsData(true);
          setMenuList(mapping);
          setMenuListDefault(mapping);
        });
    }
  }, [menuList, isData, filter]);

  const handleChangeStatus = React.useCallback(
    (checked: any, index: any) => {
      const newMenuList = cloneDeep(menuList);
      if (checked === null || checked === false) {
        newMenuList[index].enableIntegrationEap = true;
      } else {
        newMenuList[index].enableIntegrationEap = false;
      }

      setMenuList(newMenuList);
    },
    [menuList]
  );

  const { notifyUpdateItemSuccess, notifyUpdateItemError } =
    appMessageService.useCRUDMessage();

  const handleSaveMenu = React.useCallback(() => {
    setIsLoading(true);
    menuRepository.updateEnableIntegrationEap(menuList).subscribe(
      (res) => {
        notifyUpdateItemSuccess({
          message: "Cập nhật cấu hình phê duyệt thành công",
        });
        setIsLoading(false);
        setIsEditable(false);
      },
      (error) => {
        if (error.response && error.response.status === 400) {
          notifyUpdateItemError({
            message: "Cập nhật cấu hình phê duyệt thất bại",
          });
        }
        setIsLoading(false);
      }
    );
  }, [menuList, notifyUpdateItemError, notifyUpdateItemSuccess]);

  const handleChange = (e: any) => {
    handleChangeInputSearch(e);
    dispatch({
      type: FilterActionEnum.UPDATE,
      payload: {
        name: {
          contain: e,
        },
        search: "",
      },
    });
    setIsData(false);
  };

  const columns: ColumnProps<Menu>[] = useMemo(
    () => [
      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "id"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("menu.eap.id")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        width: 80,
        key: nameof(menuList[0].id),
        dataIndex: nameof(menuList[0].id),
        sorter: true,
        ellipsiss: true,
        render(...params: [string, Menu, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText value={String(params[2] + 1)} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "name"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("menu.eap.name")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        key: nameof(menuList[0].name),
        dataIndex: nameof(menuList[0].name),
        ellipsiss: true,
        width: 300,
        render(...params: [string, Menu, number]) {
          return (
            <LayoutCell orderType="left" tableSize="md">
              <OneLineText value={params[0]} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "enableIntegrationEap"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("menu.eap.enableIntegrationEap")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        ellipsiss: true,
        key: nameof(menuList[0].enableIntegrationEap),
        dataIndex: nameof(menuList[0].enableIntegrationEap),
        width: 200,
        render(...params: [boolean, Menu, number]) {
          return (
            //fill the render field after generate code;
            <LayoutCell orderType="left" tableSize="md">
              <Switch
                checked={params[0]}
                onChange={() => {
                  if (isEditable) {
                    handleChangeStatus(params[0], params[2]);
                  }
                }}
                className="switch_status"
                disabled={!isEditable}
              />
            </LayoutCell>
          );
        },
      },
    ],
    [menuList, handleChangeStatus, translate, isEditable]
  );

  return (
    <Spin spinning={isLoading}>
      <div className="page-content page-content-dxg" id="page-content-dxg-id">
        <div className="info-component ml-4 mb-3">
          <span>{translate("menu.eap.configuration")}</span>
        </div>

        <div className="page page-master m-t--lg m-b--xxs">
          <div className="pt-4 pb-1 ml-3">
            <h5 className="font-bold page-title">
              {translate("menu.eap.title")}
            </h5>
          </div>

          <div className="page-master__content">
            <div className="page-master__filter-wrapper d-flex align-items-center justify-content-between px-3">
              <div className="page-master__filter-action-search d-flex align-items-center">
                <InputSearch
                  value={filter.name.contain}
                  classFilter={MenuFilter}
                  placeHolder={translate("general.placeholder.search")}
                  onChange={handleChange}
                  animationInput={filter?.search ? false : true}
                />
              </div>

              <div className="page-master__actions  d-flex align-items-center justify-content-start">
                <div className="page-master__filter-action d-flex align-items-center">
                  {validAction("update-enable-integration-eap") &&
                    isEditable === false && (
                      <Button
                        type="primary"
                        className="btn--lg btn-blue ml-3"
                        onClick={() => setIsEditable(!isEditable)}
                      >
                        {translate("general.actions.edit")}
                      </Button>
                    )}
                  {validAction("update-enable-integration-eap") && isEditable && (
                    <div className="mb-0 d-flex justify-content-between background-w-dxg border-tl-8-dxg">
                      <Button
                        type="secondary"
                        className="btn--lg btn-red"
                        icon={<Close16 />}
                        onClick={() => {
                          setMenuList(menuListDefault);
                          setIsEditable(!isEditable);
                        }}
                      >
                        {translate("general.actions.close")}
                      </Button>
                      <Button
                        type="primary"
                        className="btn--lg btn-orange-wIcon ml-3"
                        icon={<Send16 />}
                        onClick={handleSaveMenu}
                      >
                        {translate("general.actions.save")}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="page-master__content-table">
            <StandardTable
              rowKey={nameof(menuList[0].id)}
              columns={columns}
              dataSource={menuList}
              isDragable={true}
              tableSize={"md"}
              scroll={{ x: 1000 }}
            />
          </div>
        </div>
      </div>
    </Spin>
  );
}
export default IntegrationEapConfigurationMaster;
